export const GRADE_YEAR_STRINGS = {
  NOT_SPECIFIED: 'NOT SPECIFIED',
  ELEMENTARY: 'ELEMENTARY',
  _6: '6TH',
  _7: '7TH',
  _8: '8TH',
  _9: 'FRESHMAN',
  _10: 'SOPHOMORE',
  _11: 'JUNIOR',
  _12: 'SENIOR',
  GRADUATE: 'GRADUATE',
};

export const GRADE_YEARS = {
  NOT_SPECIFIED: -1,
  ELEMENTARY: 5,
  _6: 6,
  _7: 7,
  _8: 8,
  _9: 9,
  _10: 10,
  _11: 11,
  _12: 12,
  GRADUATE: 13,
};

export const MIDDLE_SCHOOL_YEARS = {
  _6: 6,
  _7: 7,
  _8: 8,
};

export const MIDDLE_SCHOOL_YEARS_LIST = [6, 7, 8];

export const HIGH_SCHOOL_YEARS = {
  _9: 9,
  _10: 10,
  _11: 11,
  _12: 12,
};

export const ELEMENTARY_SCHOOL_GRADES = [0, 1, 2, 3, 4, 5];
export const MIDDLE_HIGH_SCHOOL_GRADES = [6, 7, 8, 9, 10, 11, 12];
export const EIGHTH_AND_HIGH_SCHOOL_GRADES = [8, 9, 10, 11, 12];
export const HIGH_SCHOOL_YEARS_LIST = [9, 10, 11, 12];
export const GRADUATED_GRADE = 99;

export const STUDENT_SCOPE = {
  ELEMENTARY: 'elementary',
  SECONDARY: 'secondary',
  ELEMENTARY_AND_SECONDARY: 'elementary_and_secondary',
};

export const SCHOOL_TYPE_TO_GRADE_LIST = {
  Elementary: ELEMENTARY_SCHOOL_GRADES,
  'Middle School': MIDDLE_SCHOOL_YEARS_LIST,
  'High School': HIGH_SCHOOL_YEARS_LIST,
};
